var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsFill(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.869-185.869v-79.218h74.913v-289.869q0-88.914 51.478-160.588 51.478-71.674 138.131-90.369v-18.609q0-29.239 20.302-49.707 20.303-20.467 49.307-20.467t49.307 20.467q20.302 20.468 20.302 49.707v18.609q86.653 18.13 138.414 90 51.761 71.87 51.761 160.957v289.869h74.912v79.218H145.869ZM480.283-60.782q-34.95 0-59.878-24.994-24.927-24.994-24.927-60.093h169.609q0 35.261-25.044 60.174Q515-60.782 480.283-60.782Z"
  })));
}
export default SvgNotificationsFill;